<template lang="pug">
.d-inline-block
    //- Button
    font-awesome-icon.text-info.ml-3(icon="question-circle", @click="showModal = true")

    //- Modal
    .modal-backdrop.fade.show(v-if="showModal")
    .modal(:class="{ 'd-block': showModal }")
        .modal-dialog.modal-md.modal-dialog-scrollable: .modal-content
            header.modal-header
                h5.modal-title {{ title }}
                button.close(type="button", @click="showModal = false") &times;

            .modal-body(v-html="body")

            footer.modal-footer
                button.btn.btn-primary(type="button", @click="showModal = false") Schließen
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core'
import { faQuestionCircle } from '@fortawesome/free-solid-svg-icons'

library.add(faQuestionCircle)

export default {
    props: {
        title: {
            type: String,
            required: false,
            default: 'Hinweis'
        },
        body: {
            type: String,
            required: true
        }
    },
    data () {
        return {
            showModal: false
        }
    }
}
</script>

<style lang="scss" scoped>
.fa-question-circle {
    cursor: pointer;
}
</style>
